import { Button, Flex, Typography } from 'antd';
import { routesPath } from '../../common/constants/routesPath';
import { spacing } from '../../theming';

const MANAGE_PATH = `${routesPath.ROOT.USER_SETTINGS}#email-preferences`;

// a real link (full load): Settings sits behind sign-in, which the unsubscribe page knows nothing about
export default function ManageLink({ t, asButton = false }) {
    return (
        <Flex vertical align="center" gap={spacing[0.5]}>
            <Button type={asButton ? 'primary' : 'link'} size={asButton ? 'large' : 'middle'} href={MANAGE_PATH}>
                {t('unsubscribe:manageLink')}
            </Button>
            {!asButton && <Typography.Text type="secondary">{t('unsubscribe:useSettings.text')}</Typography.Text>}
        </Flex>
    );
}
